import { RemoteData } from 'app/infrastructure/remote-data';
import { ApiResponse } from 'app/types-shared';
import { endpoint } from 'app/area/shared/endpoints';

export const api = {
  date: async (dbFunction: number, utcOffset: number): Promise<string> => {

    const response = await new RemoteData(endpoint.date).resource<ApiResponse<any>>()
      .withId(dbFunction)
      .filter({
        utcOffset
      })
      .single();

    return response && response.data && response.data.date;
  }
};
